import { Trans } from 'react-i18next';

const ROLES = [
  {
    label: <Trans i18nKey="admin" />,
    value: 'admin',
    desc: <Trans i18nKey="adminRoleDesc" />
  },
  {
    label: <Trans i18nKey="member" />,
    value: 'user',
    desc: <Trans i18nKey="memberRoleDesc" />
  }
];

export { ROLES };
